import { render, staticRenderFns } from "./PageContain.vue?vue&type=template&id=215db26d"
import script from "./PageContain.vue?vue&type=script&lang=js"
export * from "./PageContain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports